var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWildlife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.16,7.81a10.81,10.81,0,0,1-1.3-.73c-1.48-1.16-3.11-1.12-5-.66A2.88,2.88,0,0,1,9.34,9,7,7,0,0,1,7.55,13.5a1.12,1.12,0,0,1-.84.23A6.24,6.24,0,0,1,1.59,7.48,6.39,6.39,0,0,1,6.8,1.37,6.34,6.34,0,0,1,14.16,7.81Zm-10.62-3c-.1,0-.14,0-.15,0-2,2.69-.19,7.28,3.13,7.89a.69.69,0,0,0,.55-.16,5.67,5.67,0,0,0,1.27-4A1.27,1.27,0,0,0,6.47,7.41,2.17,2.17,0,0,1,3.55,5.63,6,6,0,0,1,3.54,4.78ZM7.93,2.24V5.36a4.7,4.7,0,0,1,1.35-.18,1.6,1.6,0,0,0,2.07-1.42,1,1,0,0,0,0-.19A5,5,0,0,0,7.93,2.24Zm-1,.27A3,3,0,0,0,4.51,5.12,1.25,1.25,0,0,0,5.65,6.59,1.23,1.23,0,0,0,6.92,5.31C6.94,4.4,6.92,3.49,6.92,2.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.6,4.39c-.3.2-.51.45-.64.41s-.32-.32-.48-.5c.17-.13.34-.37.51-.38S6.32,4.17,6.6,4.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildlife);
export default __webpack_public_path__ + "static/media/wildlife.30fe2c9c5687290633b52cd369f64a0d.svg";
export { ForwardRef as ReactComponent };